import React, {useMemo, useState} from "react";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import Popover from '@material-ui/core/Popover';
import MenuItem from '@material-ui/core/MenuItem';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import {Avatar} from "@material-ui/core";
import previews from './textures/map-preview';
import { useViewer, useGlobalSettings } from "../hooks";
import { OpenLayersIcon } from "../components";
import { getGradient } from "../theme";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    preview: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginRight: theme.spacing(2),
      borderRadius: theme.spacing(1),
      boxShadow: "2px 2px 3px rgba(0,0,0,0.5)"
    }
  }),
);

/** No base map (custom gradient) */
const EmptyBasemapIcon = () => {
  const classes = useStyles();
  const {aerialBackground} = useGlobalSettings();

  const aerialGradient = useMemo(() => {
    return getGradient(aerialBackground);
  }, [aerialBackground]);

  return (
    <div
      className={classes.preview}
      style={{
        backgroundImage: aerialGradient
      }}
    />
  );
};

/** Standard layer icon */
const LayerPreviewIcon = (props) => {
  const {layerID} = props;

  const classes = useStyles();

  return (
    <Avatar
      src={previews[layerID]}
      className={classes.preview}
      alt="icon"
    />
  );
};

export const LayerSwitcher = (props) => {
  const {clearTooltipText} = props;

  const {viewer} = useViewer();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    clearTooltipText();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (layerID) => {
    const minimap = viewer.minimap;
    minimap.setVisibleBasemap(layerID);
  };

  const getMenuItems = () => {
    const minimap = viewer.minimap;
    const layers = minimap.basemapIDs;
    const selected = minimap.activeBasemap;

    return layers.map(layer => {
      const icon = layer.id === null
        ? <EmptyBasemapIcon/>
        : <LayerPreviewIcon layerID={layer.id}/>;

      return {
        id: layer.id,
        text: layer.text,
        icon: icon,
        selected: layer.id === selected
      };
    });
  };

  const open = Boolean(anchorEl);
  const options = viewer ? getMenuItems() : [];

  return (
    <React.Fragment>
      <OpenLayersIcon
        placement={"bottom-left"}
        onClick={handleClick}
      >
        <FormatListBulletedIcon/>
      </OpenLayersIcon>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {options.map(option => {
          return (
            <MenuItem
              key={option.id}
              style={{
                fontSize: "0.9em"
              }}
              selected={option.selected}
              onClick={() => {
                handleSelect(option.id);
                handleClose();
              }}
            >
              {option.icon}
              {option.text}
            </MenuItem>
          );
        })}
      </Popover>

    </React.Fragment>
  );
};